/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Common components
import FormCard from "../../Common/Childs/Structure/FormCard";
import Description from "../../Common/Childs/Structure/Description";
import Title from "../../Common/Childs/Structure/Title";

// Form component specific to this page
import Form from "./Childs/Form";
import { useWallet } from "../../../context/WalletContextProvider";
import { useGlobal } from "../../../context/GlobalContextProvider";

// Initial state for the sponsor information form
const initialState = {
  sponsor_name: "",
  sponsor_email: "",
  payment_address: "",
};

// Main component for the Sponsor form page
export default function Index() {
  // Custom hook to access shared state and functions
  const { account } = useWallet()
  const { setSpinner } = useGlobal()

  // State to manage form data and copied data for comparison
  const [formData, setFormData] = useState(initialState);
  const [copyData, setCopyData] = useState();

  // Navigation hook for programmatic routing
  const navigate = useNavigate();

  // Function to fetch and load sponsor data for the given wallet address
  const loadTableData = async () => {
    setSpinner(true); // Show loading spinner
    const res = await fetch(`/api/sponsor/wallet/${account}`); // Fetch sponsor data from API

    if (res.status === 200) { // If data fetch is successful
      const data = await res.json(); // Parse response data
      const { sponsor_name, sponsor_email, payment_address } = data;

      // Update form data state with fetched data, setting defaults if necessary
      setFormData({
        sponsor_name: sponsor_name || "",
        sponsor_email: sponsor_email || "",
        payment_address: payment_address && !account ? "" : (payment_address ? payment_address : account)
      });

      // Store a copy of initial data to detect changes later
      setCopyData({
        sponsor_name: sponsor_name || "",
        sponsor_email: sponsor_email || "",
        payment_address: payment_address && account === 0 ? "" : (payment_address ? payment_address : account)
      });
    }
    setSpinner(false); // Hide loading spinner
  };

  // Load sponsor data when account changes
  useEffect(() => {
    if (account) {
      loadTableData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  // Function to handle form submission
  const handleSubmit = async (data) => {
    const { sponsor_name, sponsor_email, payment_address } = data;
    setSpinner(true); // Show loading spinner

    // Send updated sponsor data to server
    await fetch(`/api/sponsor/wallet/${account}`, {
      method: "PUT",
      body: JSON.stringify({
        sponsor_name: sponsor_name,
        sponsor_address: account,
        sponsor_email: sponsor_email,
        payment_address: payment_address,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }).then((res) => {
      setSpinner(false);               // Hide loading spinner
      navigate("/sponsor/campaign");   // Navigate to sponsor campaign page
    });
  };

  return (
    <>
      {/* Render title, description, and form card with embedded form */}
      <Title title="About the Campaign Sponsor" />
      <Description text="Please enter information about the Sponsor of this Campaign." />
      <FormCard>
        <Form
          handleSubmit={handleSubmit}        // Pass handleSubmit to Form component
          formData={formData}                // Pass formData state to Form component
          setFormData={setFormData}          // Pass setFormData function to Form component
          copyData={copyData}                // Pass initial copyData for change detection
          isWalletConnected={account !== null} // Pass wallet connection status to Form
        />
      </FormCard>
    </>
  );
}
